import {connect} from 'react-redux';
import DragLayer from '../components/drag-layer/drag-layer.jsx';

const mapStateToProps = state => ({
    dragging: state.bitByteGui.assetDrag.dragging,
    currentOffset: state.bitByteGui.assetDrag.currentOffset,
    img: state.bitByteGui.assetDrag.img
});

export default connect(mapStateToProps)(DragLayer);
